<div class="ion-padding-start ion-text-start">
  <ion-text color="dark" class="title">
    <h2 class="title__text">{{ title }}</h2>
  </ion-text>
  <ion-text color="medium">
    <p>{{ subtitle }}</p>
  </ion-text>
</div>
